import Header from "./modules/Header";
import RoutePage from "./app/RoutePage.jsx";
import { getAppIsInited } from "./app/appSelectors.js";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import AccessProvider from "./modules/AccessLevels/AccessProvider.js";
import { appInitAction } from "./app/appActions.js";
import PopupProvider from "./modules/Popup/PopupProvider";
import { GlobalStyles } from "./modules/GlobalStyles/GlobalStyles";

function App(props) {
    const dispatch = useDispatch();
    const isInited = useSelector(getAppIsInited)

    useEffect(() => {
        dispatch(appInitAction());
    }, [dispatch]);

    return <AccessProvider>
        <PopupProvider>
            <Header/>
            <GlobalStyles/>
            {
                !!isInited && <RoutePage/>
            }
        </PopupProvider>
    </AccessProvider>;
}

export default App;
